import {
  AccountFilter,
  AccountTypeFilter,
  AutomationFilter,
  BookFilter,
  BookingChannelFilter,
  CategoryFilter,
  ClassificationFilter,
  ContactsFilter,
  ListingsFilter,
  PartyFilter,
  RecurringFeeFilter,
  ReservationLineTypeFilter,
} from '@vrplatform/table-filter';

export * from '@vrplatform/table-filter';

export const CustomFilter = {
  Automation: AutomationFilter,
  Book: BookFilter,
  Category: CategoryFilter,
  Classification: ClassificationFilter,
  Listings: ListingsFilter,
  Contacts: ContactsFilter,
  Party: PartyFilter,
  AccountType: AccountTypeFilter,
  Account: AccountFilter,
  BookingChannel: BookingChannelFilter,
  ReservationLineType: ReservationLineTypeFilter,
  RecurringFee: RecurringFeeFilter,
};
